import { Link } from 'react-router-dom';

export default function BrandSection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-[35%] w-full">
            <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300 text-foreground-600 text-xs font-medium mb-6">
              关于我们
            </span>
            <div className="rounded-2xl overflow-hidden aspect-[4/5] max-w-sm mx-auto lg:max-w-none bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20editorial%20office%20workspace%20with%20warm%20lighting%2C%20laptop%20on%20wooden%20desk%2C%20coffee%20cup%2C%20minimal%20creative%20studio%20atmosphere%2C%20soft%20natural%20light%20from%20window%2C%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20watermark%2C%20professional%20workspace%20photography&width=600&height=750&seq=brand-about-01&orientation=portrait"
                alt="51黑料网办公环境"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:w-[65%]">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              做全网最可信赖的
            </h2>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              吃瓜信息聚合
            </h2>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-6">
              平台
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 max-w-lg">
              51黑料网成立于2024年，由一群热爱追踪娱乐圈动态的资深媒体人创办。我们的使命是为广大吃瓜群众提供最快速、最全面、最真实的娱乐资讯与黑料爆料。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-lg">
              我们坚持人工审核与AI辅助相结合的内容审核机制，确保每一条信息的真实性和可信度，让吃瓜不再靠猜测。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-up-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}